import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-280ad662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "koumoku tsukinCont cwT_1" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "自")
], -1))
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "～")
], -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "suuryou tsukinCont cwT_2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "tanka tsukinCont cwT_3" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "kingaku tsukinCont cwT_4" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control form-control-sm",
          maxlength: "50",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.c_addchg_section_start) = $event)),
          disabled: _ctx.isDisable
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.item.c_addchg_section_start]
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control form-control-sm",
          maxlength: "50",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.c_addchg_section_end) = $event)),
          disabled: _ctx.isDisable
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.item.c_addchg_section_end]
        ])
      ])
    ]),
    _createElementVNode("td", _hoisted_7, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control form-control-sm",
        maxlength: "50",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.c_addchg_transport) = $event)),
        disabled: _ctx.isDisable
      }, null, 8, _hoisted_8), [
        [_vModelText, _ctx.item.c_addchg_transport]
      ])
    ]),
    _createElementVNode("td", _hoisted_9, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control form-control-sm",
        maxlength: "9",
        onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.kanmaDel($event))),
        onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.kanmaIns($event))),
        style: {"text-align":"right"},
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.cnvFare) = $event)),
        disabled: _ctx.isDisable
      }, null, 40, _hoisted_10), [
        [_vModelText, _ctx.item.cnvFare]
      ])
    ]),
    _createElementVNode("td", _hoisted_11, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control form-control-sm",
        maxlength: "9",
        onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.kanmaDel($event))),
        onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.kanmaIns($event))),
        style: {"text-align":"right"},
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.cnvPass) = $event)),
        disabled: _ctx.isDisable
      }, null, 40, _hoisted_12), [
        [_vModelText, _ctx.item.cnvPass]
      ])
    ])
  ]))
}